
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/centro-de-ayuda",
      function () {
        return require("private-next-pages/centro-de-ayuda/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/centro-de-ayuda"])
      });
    }
  